<mat-toolbar class="toolbar-background">
  <div class="flex items-center" [ngStyle]="{
    'width': this.maxContentWidth ?? '100%',
    'margin': '0 auto'
  }">
    <div *ngIf="logo | async as img">
        <a [href]="pathToCustomer" target="_blank">
            <img [src]="logo | async" alt="Theme logo" [ngClass]="imageClass">
        </a>
    </div>
    <div class="flex-auto"></div>
    <div>
      <a [href]="pathToPROPUP" target="_blank" class="flex items-center">
        <span class="text-xs text-gray-500">{{'general.imprint' | translate}} </span>
        <img class="!w-20 pl-2" [src]="pathToLogo" alt="PROPUP" />
      </a>
    </div>
  </div>
</mat-toolbar>